import { useNavigate } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getAppSettings, updateAppSettings } from "../../helpers/http_settings_requests";

export default function SettingsHouse() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const { data, isFetching } = useQuery({
        queryKey: ["getAppSettings"],
        queryFn: getAppSettings,
        staleTime: 1000 * 5,
    });

    const { data: settings } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Dados da casa",
            fields: [
                { name: "company_name", label: "Nome", type: "text", required: true },
                { name: "company_cnpj", label: "CNPJ", type: "text" },
                { name: "company_phone", label: "Telefone", type: "text" },
                { name: "company_logo", label: "URL do logo", type: "text", fullWidth: true, helpertext: "Usado no e-mail de pronto e entregue." },
            ],
        },
        {
            title: "Prazos",
            fields: [
                {
                    name: "delivery_business_days",
                    label: "Dias úteis até a entrega",
                    type: "number",
                    required: true,
                    helpertext: "Usado como prazo sugerido no pedido novo.",
                },
                {
                    name: "workdays",
                    label: "Dias úteis",
                    type: "text",
                    helpertext: "0 domingo até 6 sábado. Padrão: 1,2,3,4,5 (segunda a sexta).",
                },
            ],
        },
        {
            title: "E-mail: pedido pronto",
            fields: [
                { name: "email_ready_subject", label: "Assunto", type: "text", fullWidth: true, required: true },
                {
                    name: "email_ready_body",
                    label: "Texto",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                    helpertext: "Variáveis: {nome} {pedido} {peca} {empresa} {telefone}",
                },
            ],
        },
        {
            title: "E-mail: pedido entregue",
            fields: [
                { name: "email_delivered_subject", label: "Assunto", type: "text", fullWidth: true, required: true },
                {
                    name: "email_delivered_body",
                    label: "Texto",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                    helpertext: "Variáveis: {nome} {pedido} {peca} {empresa} {telefone}",
                },
            ],
        },
    ];

    const handleSubmit = (formData) => {
        updateAppSettings(formData, () => {
            queryClient.invalidateQueries({ queryKey: ["getAppSettings"] });
            navigate("/configuracao-casa");
        });
    };

    return (
        <DynamicFormPage
            isLoading={isFetching}
            initialData={settings}
            title="Casa"
            formFieldList={formFieldList}
            onCancel={() => navigate(-1)}
            onSubmit={handleSubmit}
            submitButtonText="Salvar"
        />
    );
}
